import { MedigapPlan } from "../../utils/plans";

const plans: MedigapPlan[] = [
  {
    plan_type: "MEDIGAP_PLAN_TYPE_A",
    plan_details_name: "medigap.a.plan_details_name",
    plan_policy_name: "medigap.a.plan_policy_name",
    part_a_deductible: "$1,408",
    part_b_deductible: "$198",
    part_b_coinsurance: "$0",
    plan_benefits: "",
    hospital_stay_1_60: "medigap.ma_core.hospital_stay_1_60",
    hospital_stay_61_90: "$0",
    hospital_stay_91_150: "medigap.ma_core.hospital_stay_91_150",
    hospital_stay_additional_365:
      "medigap.ma_core.hospital_stay_additional_365",
    hospital_stay_after_365: "medigap.ma_core.hospital_stay_after_365",
    snf_days_1_20: "$0",
    snf_days_21_100: "medigap.ma_core.snf_days_21_100",
    snf_after_100_days: "medigap.ma_core.hospital_stay_after_365",
    a_blood_first_3: "$0",
    a_blood_after_3: "$0",
    hospice: "$0",
    home_health: "$0",
    dme_first: "medigap.ma_core.dme_first",
    dme_remainder_then: "$0",
    covered_medical_services_first: "medigap.ma_core.dme_first",
    covered_medical_services_then: "$0",
    preventive_services: "medigap.mn_basic.prev_serv_cover",
    excess_charges: "medigap.ma_core.hospital_stay_after_365",
    b_blood_first_3: "$0",
    b_blood_after_3: "medigap.ma_core.b_blood_after_3",
    tests_diagnostics: "$0",
    foreign_travel_emergency: "medigap.ma_core.hospital_stay_after_365",
    plan_name: "medigap.a.name",
    part_b_coinsurance_note: "medigap.a.part_b_coinsurance",
  },
  {
    plan_type: "MEDIGAP_PLAN_TYPE_B",
    plan_details_name: "medigap.b.plan_details_name",
    plan_policy_name: "medigap.b.plan_policy_name",
    part_a_deductible: "$0",
    part_b_deductible: "$198",
    part_b_coinsurance: "$0",
    plan_benefits: "2",
    hospital_stay_1_60: "$0",
    hospital_stay_61_90: "$0",
    hospital_stay_91_150: "medigap.ma_core.hospital_stay_91_150",
    hospital_stay_additional_365:
      "medigap.ma_core.hospital_stay_additional_365",
    hospital_stay_after_365: "medigap.ma_core.hospital_stay_after_365",
    snf_days_1_20: "$0",
    snf_days_21_100: "medigap.ma_core.snf_days_21_100",
    snf_after_100_days: "medigap.ma_core.hospital_stay_after_365",
    a_blood_first_3: "$0",
    a_blood_after_3: "$0",
    hospice: "$0",
    home_health: "$0",
    dme_first: "medigap.ma_core.dme_first",
    dme_remainder_then: "$0",
    covered_medical_services_first: "medigap.ma_core.dme_first",
    covered_medical_services_then: "$0",
    preventive_services: "medigap.mn_basic.prev_serv_cover",
    excess_charges: "medigap.ma_core.hospital_stay_after_365",
    b_blood_first_3: "$0",
    b_blood_after_3: "medigap.ma_core.b_blood_after_3",
    tests_diagnostics: "$0",
    foreign_travel_emergency: "medigap.ma_core.hospital_stay_after_365",
    plan_name: "medigap.b.name",
    part_b_coinsurance_note: "medigap.a.part_b_coinsurance",
  },
  {
    plan_type: "MEDIGAP_PLAN_TYPE_C",
    plan_details_name: "medigap.c.plan_details_name",
    plan_policy_name: "medigap.c.plan_policy_name",
    part_a_deductible: "$0",
    part_b_deductible: "$0",
    part_b_coinsurance: "$0",
    plan_benefits: "1,2,3,5",
    hospital_stay_1_60: "$0",
    hospital_stay_61_90: "$0",
    hospital_stay_91_150: "medigap.ma_core.hospital_stay_91_150",
    hospital_stay_additional_365:
      "medigap.ma_core.hospital_stay_additional_365",
    hospital_stay_after_365: "medigap.ma_core.hospital_stay_after_365",
    snf_days_1_20: "$0",
    snf_days_21_100: "$0",
    snf_after_100_days: "medigap.ma_core.hospital_stay_after_365",
    a_blood_first_3: "$0",
    a_blood_after_3: "$0",
    hospice: "$0",
    home_health: "$0",
    dme_first: "$0",
    dme_remainder_then: "$0",
    covered_medical_services_first: "$0",
    covered_medical_services_then: "$0",
    preventive_services: "medigap.mn_basic.prev_serv_cover",
    excess_charges: "medigap.ma_core.hospital_stay_after_365",
    b_blood_first_3: "$0",
    b_blood_after_3: "$0",
    tests_diagnostics: "$0",
    foreign_travel_emergency_first: "$250",
    foreign_travel_emergency_remainder_then:
      "medigap.mn_n.foreign_travel_emergency_remainder_then",
    plan_name: "medigap.c.name",
    part_b_coinsurance_note: "medigap.a.part_b_coinsurance",
  },
  {
    plan_type: "MEDIGAP_PLAN_TYPE_D",
    plan_details_name: "medigap.d.plan_details_name",
    plan_policy_name: "medigap.d.plan_policy_name",
    part_a_deductible: "$0",
    part_b_deductible: "$198",
    part_b_coinsurance: "$0",
    plan_benefits: "1,2,5",
    hospital_stay_1_60: "$0",
    hospital_stay_61_90: "$0",
    hospital_stay_91_150: "medigap.ma_core.hospital_stay_91_150",
    hospital_stay_additional_365:
      "medigap.ma_core.hospital_stay_additional_365",
    hospital_stay_after_365: "medigap.ma_core.hospital_stay_after_365",
    snf_days_1_20: "$0",
    snf_days_21_100: "$0",
    snf_after_100_days: "medigap.ma_core.hospital_stay_after_365",
    a_blood_first_3: "$0",
    a_blood_after_3: "$0",
    hospice: "$0",
    home_health: "$0",
    dme_first: "medigap.ma_core.dme_first",
    dme_remainder_then: "$0",
    covered_medical_services_first: "medigap.ma_core.dme_first",
    covered_medical_services_then: "$0",
    preventive_services: "medigap.mn_basic.prev_serv_cover",
    excess_charges: "medigap.ma_core.hospital_stay_after_365",
    b_blood_first_3: "$0",
    b_blood_after_3: "medigap.ma_core.b_blood_after_3",
    tests_diagnostics: "$0",
    foreign_travel_emergency_first: "$250",
    foreign_travel_emergency_remainder_then:
      "medigap.mn_n.foreign_travel_emergency_remainder_then",
    plan_name: "medigap.d.name",
    part_b_coinsurance_note: "medigap.a.part_b_coinsurance",
  },
  {
    plan_type: "MEDIGAP_PLAN_TYPE_F",
    plan_details_name: "medigap.f.plan_details_name",
    plan_policy_name: "medigap.f.plan_policy_name",
    part_a_deductible: "$0",
    part_b_deductible: "$0",
    part_b_coinsurance: "$0",
    plan_benefits: "1,2,3,4,5",
    hospital_stay_1_60: "$0",
    hospital_stay_61_90: "$0",
    hospital_stay_91_150: "medigap.ma_core.hospital_stay_91_150",
    hospital_stay_additional_365:
      "medigap.ma_core.hospital_stay_additional_365",
    hospital_stay_after_365: "medigap.ma_core.hospital_stay_after_365",
    snf_days_1_20: "$0",
    snf_days_21_100: "$0",
    snf_after_100_days: "medigap.ma_core.hospital_stay_after_365",
    a_blood_first_3: "$0",
    a_blood_after_3: "$0",
    hospice: "$0",
    home_health: "$0",
    dme_first: "$0",
    dme_remainder_then: "$0",
    covered_medical_services_first: "$0",
    covered_medical_services_then: "$0",
    preventive_services: "medigap.mn_basic.prev_serv_cover",
    excess_charges: "$0",
    b_blood_first_3: "$0",
    b_blood_after_3: "$0",
    tests_diagnostics: "$0",
    foreign_travel_emergency_first: "$250",
    foreign_travel_emergency_remainder_then:
      "medigap.mn_n.foreign_travel_emergency_remainder_then",
    plan_name: "medigap.f.name",
    part_b_coinsurance_note: "medigap.a.part_b_coinsurance",
  },
  {
    plan_type: "MEDIGAP_PLAN_TYPE_HIGH_F",
    plan_details_name: "medigap.high_f.plan_details_name",
    plan_policy_name: "medigap.high_f.plan_policy_name",
    part_a_deductible: "$0",
    part_b_deductible: "$0",
    part_b_coinsurance: "$0",
    plan_benefits: "1,2,3,4,5",
    hospital_stay_1_60: "$0",
    hospital_stay_61_90: "$0",
    hospital_stay_91_150: "medigap.ma_core.hospital_stay_91_150",
    hospital_stay_additional_365:
      "medigap.ma_core.hospital_stay_additional_365",
    hospital_stay_after_365: "medigap.ma_core.hospital_stay_after_365",
    snf_days_1_20: "$0",
    snf_days_21_100: "$0",
    snf_after_100_days: "medigap.ma_core.hospital_stay_after_365",
    a_blood_first_3: "$0",
    a_blood_after_3: "$0",
    hospice: "$0",
    home_health: "$0",
    dme_first: "$0",
    dme_remainder_then: "$0",
    covered_medical_services_first: "$0",
    covered_medical_services_then: "$0",
    preventive_services: "medigap.mn_basic.prev_serv_cover",
    excess_charges: "$0",
    b_blood_first_3: "$0",
    b_blood_after_3: "$0",
    tests_diagnostics: "$0",
    foreign_travel_emergency_first: "$250",
    foreign_travel_emergency_remainder_then:
      "medigap.mn_n.foreign_travel_emergency_remainder_then",
    plan_name: "medigap.high_f.name",
    part_b_coinsurance_note: "medigap.high_f.part_b_coinsurance",
    total_deductible: "$2,340",
  },
  {
    plan_type: "MEDIGAP_PLAN_TYPE_G",
    plan_details_name: "medigap.g.plan_details_name",
    plan_policy_name: "medigap.g.plan_policy_name",
    part_a_deductible: "$0",
    part_b_deductible: "$198",
    part_b_coinsurance: "$0",
    plan_benefits: "1,2,4,5",
    hospital_stay_1_60: "$0",
    hospital_stay_61_90: "$0",
    hospital_stay_91_150: "medigap.ma_core.hospital_stay_91_150",
    hospital_stay_additional_365:
      "medigap.ma_core.hospital_stay_additional_365",
    hospital_stay_after_365: "medigap.ma_core.hospital_stay_after_365",
    snf_days_1_20: "$0",
    snf_days_21_100: "$0",
    snf_after_100_days: "medigap.ma_core.hospital_stay_after_365",
    a_blood_first_3: "$0",
    a_blood_after_3: "$0",
    hospice: "$0",
    home_health: "$0",
    dme_first: "medigap.ma_core.dme_first",
    dme_remainder_then: "$0",
    covered_medical_services_first: "medigap.ma_core.dme_first",
    covered_medical_services_then: "$0",
    preventive_services: "medigap.mn_basic.prev_serv_cover",
    excess_charges: "$0",
    b_blood_first_3: "$0",
    b_blood_after_3: "medigap.ma_core.b_blood_after_3",
    tests_diagnostics: "$0",
    foreign_travel_emergency_first: "$250",
    foreign_travel_emergency_remainder_then:
      "medigap.mn_n.foreign_travel_emergency_remainder_then",
    plan_name: "medigap.g.name",
    part_b_coinsurance_note: "medigap.a.part_b_coinsurance",
  },
  {
    plan_type: "MEDIGAP_PLAN_TYPE_HIGH_G",
    plan_details_name: "medigap.high_g.plan_details_name",
    plan_policy_name: "medigap.high_g.plan_policy_name",
    part_a_deductible: "$0",
    part_b_deductible: "$198",
    part_b_coinsurance: "$0",
    plan_benefits: "1,2,4,5",
    hospital_stay_1_60: "$0",
    hospital_stay_61_90: "$0",
    hospital_stay_91_150: "medigap.ma_core.hospital_stay_91_150",
    hospital_stay_additional_365:
      "medigap.ma_core.hospital_stay_additional_365",
    hospital_stay_after_365: "medigap.ma_core.hospital_stay_after_365",
    snf_days_1_20: "$0",
    snf_days_21_100: "$0",
    snf_after_100_days: "medigap.ma_core.hospital_stay_after_365",
    a_blood_first_3: "$0",
    a_blood_after_3: "$0",
    hospice: "$0",
    home_health: "$0",
    dme_first: "medigap.ma_core.dme_first",
    dme_remainder_then: "$0",
    covered_medical_services_first: "medigap.ma_core.dme_first",
    covered_medical_services_then: "$0",
    preventive_services: "medigap.mn_basic.prev_serv_cover",
    excess_charges: "$0",
    b_blood_first_3: "$0",
    b_blood_after_3: "medigap.ma_core.b_blood_after_3",
    tests_diagnostics: "$0",
    foreign_travel_emergency_first: "$250",
    foreign_travel_emergency_remainder_then:
      "medigap.mn_n.foreign_travel_emergency_remainder_then",
    plan_name: "medigap.high_g.name",
    part_b_coinsurance_note: "medigap.high_f.part_b_coinsurance",
    total_deductible: "$2,340",
  },
  {
    plan_type: "MEDIGAP_PLAN_TYPE_K",
    plan_details_name: "medigap.k.plan_details_name",
    plan_policy_name: "medigap.k.plan_policy_name",
    part_a_deductible: "$704",
    part_b_deductible: "$198",
    part_b_coinsurance: "10%",
    out_pocket_limit: "medigap.mn_supp_50.out_pocket_limit",
    plan_benefits: "1,2",
    hospital_stay_1_60: "medigap.mn_supp_50.hospital_stay_1_60",
    hospital_stay_61_90: "$0",
    hospital_stay_91_150: "medigap.ma_core.hospital_stay_91_150",
    hospital_stay_additional_365:
      "medigap.ma_core.hospital_stay_additional_365",
    hospital_stay_after_365: "medigap.ma_core.hospital_stay_after_365",
    snf_days_1_20: "$0",
    snf_days_21_100: "medigap.mn_supp_50.snf_days_21_100",
    snf_after_100_days: "medigap.ma_core.hospital_stay_after_365",
    a_blood_first_3: "medigap.mn_supp_50.a_blood_first_3",
    a_blood_after_3: "$0",
    hospice: "medigap.mn_supp_50.hospice",
    home_health: "$0",
    dme_first: "medigap.ma_core.dme_first",
    dme_remainder_then: "medigap.mn_supp_50.dme_remainder_then",
    covered_medical_services_first: "medigap.ma_core.dme_first",
    covered_medical_services_then:
      "medigap.mn_supp_50.covered_medical_services_then",
    preventive_services: "medigap.mn_supp_50.preventive_services",
    excess_charges: "medigap.mn_supp_50.excess_charges",
    b_blood_first_3: "medigap.mn_supp_50.a_blood_first_3",
    b_blood_after_3: "medigap.mn_supp_50.b_blood_after_3",
    tests_diagnostics: "$0",
    foreign_travel_emergency: "medigap.ma_core.hospital_stay_after_365",
    plan_name: "medigap.k.name",
    part_a_deductible_note: "medigap.k.part_a_note",
    part_b_coinsurance_note: "medigap.k.part_b_coinsurance",
  },
  {
    plan_type: "MEDIGAP_PLAN_TYPE_L",
    plan_details_name: "medigap.l.plan_details_name",
    plan_policy_name: "medigap.l.plan_policy_name",
    part_a_deductible: "$352",
    part_b_deductible: "$198",
    part_b_coinsurance: "5%",
    out_pocket_limit: "medigap.mn_supp_75.out_pocket_limit",
    plan_benefits: "1,2",
    hospital_stay_1_60: "medigap.mn_supp_75.hospital_stay_1_60",
    hospital_stay_61_90: "$0",
    hospital_stay_91_150: "medigap.ma_core.hospital_stay_91_150",
    hospital_stay_additional_365:
      "medigap.ma_core.hospital_stay_additional_365",
    hospital_stay_after_365: "medigap.ma_core.hospital_stay_after_365",
    snf_days_1_20: "$0",
    snf_days_21_100: "medigap.mn_supp_75.snf_days_21_100",
    snf_after_100_days: "medigap.ma_core.hospital_stay_after_365",
    a_blood_first_3: "medigap.mn_supp_75.a_blood_first_3",
    a_blood_after_3: "$0",
    hospice: "medigap.mn_supp_75.hospice",
    home_health: "$0",
    dme_first: "medigap.ma_core.dme_first",
    dme_remainder_then: "medigap.mn_supp_75.dme_remainder_then",
    covered_medical_services_first: "medigap.ma_core.dme_first",
    covered_medical_services_then:
      "medigap.mn_supp_75.covered_medical_services_then",
    preventive_services: "medigap.mn_supp_50.preventive_services",
    excess_charges: "medigap.mn_supp_75.excess_charges",
    b_blood_first_3: "medigap.mn_supp_75.a_blood_first_3",
    b_blood_after_3: "medigap.mn_supp_75.b_blood_after_3",
    tests_diagnostics: "$0",
    foreign_travel_emergency: "medigap.ma_core.hospital_stay_after_365",
    plan_name: "medigap.l.name",
    part_a_deductible_note: "medigap.l.part_a_note",
    part_b_coinsurance_note: "medigap.l.part_b_coinsurance",
  },
  {
    plan_type: "MEDIGAP_PLAN_TYPE_M",
    plan_details_name: "medigap.m.plan_details_name",
    plan_policy_name: "medigap.m.plan_policy_name",
    part_a_deductible: "$704",
    part_b_deductible: "$198",
    part_b_coinsurance: "$0",
    plan_benefits: "1,2,5",
    hospital_stay_1_60: "medigap.mn_supp_50.hospital_stay_1_60",
    hospital_stay_61_90: "$0",
    hospital_stay_91_150: "medigap.ma_core.hospital_stay_91_150",
    hospital_stay_additional_365:
      "medigap.ma_core.hospital_stay_additional_365",
    hospital_stay_after_365: "medigap.ma_core.hospital_stay_after_365",
    snf_days_1_20: "$0",
    snf_days_21_100: "$0",
    snf_after_100_days: "medigap.ma_core.hospital_stay_after_365",
    a_blood_first_3: "$0",
    a_blood_after_3: "$0",
    hospice: "$0",
    home_health: "$0",
    dme_first: "medigap.ma_core.dme_first",
    dme_remainder_then: "$0",
    covered_medical_services_first: "medigap.ma_core.dme_first",
    covered_medical_services_then: "$0",
    preventive_services: "medigap.mn_basic.prev_serv_cover",
    excess_charges: "medigap.ma_core.hospital_stay_after_365",
    b_blood_first_3: "$0",
    b_blood_after_3: "medigap.ma_core.b_blood_after_3",
    tests_diagnostics: "$0",
    foreign_travel_emergency_first: "$250",
    foreign_travel_emergency_remainder_then:
      "medigap.mn_n.foreign_travel_emergency_remainder_then",
    plan_name: "medigap.m.name",
    part_a_deductible_note: "medigap.k.part_a_note",
    part_b_coinsurance_note: "medigap.a.part_b_coinsurance",
  },
  {
    plan_type: "MEDIGAP_PLAN_TYPE_N",
    plan_details_name: "medigap.n.plan_details_name",
    plan_policy_name: "medigap.n.plan_policy_name",
    part_a_deductible: "$0",
    part_b_deductible: "$198",
    part_b_coinsurance: "$0",
    plan_benefits: "1,2,5",
    hospital_stay_1_60: "$0",
    hospital_stay_61_90: "$0",
    hospital_stay_91_150: "medigap.ma_core.hospital_stay_91_150",
    hospital_stay_additional_365:
      "medigap.ma_core.hospital_stay_additional_365",
    hospital_stay_after_365: "medigap.ma_core.hospital_stay_after_365",
    snf_days_1_20: "$0",
    snf_days_21_100: "$0",
    snf_after_100_days: "medigap.ma_core.hospital_stay_after_365",
    a_blood_first_3: "$0",
    a_blood_after_3: "$0",
    hospice: "$0",
    home_health: "$0",
    dme_first: "medigap.ma_core.dme_first",
    dme_remainder_then: "$0",
    covered_medical_services_first: "medigap.ma_core.dme_first",
    covered_medical_services_then: "medigap.mn_n.covered_medical_services_then",
    preventive_services: "medigap.mn_basic.prev_serv_cover",
    excess_charges: "medigap.ma_core.hospital_stay_after_365",
    b_blood_first_3: "$0",
    b_blood_after_3: "medigap.ma_core.b_blood_after_3",
    tests_diagnostics: "$0",
    foreign_travel_emergency_first: "$250",
    foreign_travel_emergency_remainder_then:
      "medigap.mn_n.foreign_travel_emergency_remainder_then",
    plan_name: "medigap.n.name",
    part_b_coinsurance_note: "medigap.n.part_b_coinsurance",
  },
];

export default plans;
